import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_GET_DEPARTMENT_TEAMS, KEY_GET_DEPARTMENT_TEAMS } from '../constants';
import { MOCK_RESPONSE_GET_DEPARTMENT_TEAMS } from '../mocks';

type RequestGetDepartmentTeams = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_PATH_KEY
>['request']['path'];

export type ResponseGetDepartmentTeams = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_PATH_KEY
>['response']['body'];

type CallParamsGetDepartmentTeams = Omit<RequestGetDepartmentTeams, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetDepartmentTeams = ResponseGetDepartmentTeams;

type CallErrorGetDepartmentTeams = GenericApiError;

type CallSelectorsGetDepartmentTeams = unknown;

export const getDepartmentTeamsCall = createGeneralCall<
  CallParamsGetDepartmentTeams,
  CallResponseGetDepartmentTeams,
  CallErrorGetDepartmentTeams,
  CallSelectorsGetDepartmentTeams
>({
  id: KEY_GET_DEPARTMENT_TEAMS,
  method: 'get',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_DEPARTMENT_TEAMS(org, payload.departmentId);
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_DEPARTMENT_TEAMS : undefined,
});
